import axios from "axios";
import moment from "moment";

export function getNASDAQCorporateAction() {
  return axios.get(`${process.env.REACT_APP_ORBIS_API_HOST}/nasdaq_co`).then((res) => res.data);
}
